import React from 'react';
import styled from 'styled-components';

const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: #a30000;
  background-color: #faeae8;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 14px;
  gap: 8px;
  box-sizing: border-box;
  margin-bottom: 24px;
`;

type Props = {
  message: string;
  withHelpCenterLink?: boolean;
};

const Icon = () => (
  <svg
    fill="#c9190b"
    xmlns="http://www.w3.org/2000/svg"
    height="16px"
    width="16px"
    style={{ minWidth: '16px' }}
    viewBox="0 0 512 512"
  >
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
  </svg>
);

export const ErrorMessage: React.FC<Props> = ({ message, withHelpCenterLink }) => {
  return (
    <ErrorMessageContainer>
      {<Icon />}
      <div>
        {message} {withHelpCenterLink && <HelpCenterErrorFeedbackMessage />}
      </div>
    </ErrorMessageContainer>
  );
};

export const HelpCenterErrorFeedbackMessage = () => {
  return (
    <span>
      Se o problema persistir entre em contato conosco através da nossa{' '}
      <a href="https://no.descomplica.com.br/knowledge" target="_blank" rel="noreferrer">
        central de ajuda
      </a>
      .
    </span>
  );
};
